import { default as auth7tE1sZcZDUMeta } from "/app/pages/auth.vue?macro=true";
import { default as log_45inne6CMIGdEKMeta } from "/app/pages/banners/log-in.vue?macro=true";
import { default as logged_45inbikpzH6x9KMeta } from "/app/pages/banners/logged-in.vue?macro=true";
import { default as _91type_932G6hlDxcBtMeta } from "/app/pages/banners/promotion/[type].vue?macro=true";
import { default as _91sessionId_93pbuPRYJTKyMeta } from "/app/pages/chats/[sessionId].vue?macro=true";
import { default as index4CVbmc5Cq5Meta } from "/app/pages/chats/index.vue?macro=true";
import { default as chatsNJzys5tEDVMeta } from "/app/pages/chats.vue?macro=true";
import { default as email_45confirmationl1UuOPCAKuMeta } from "/app/pages/email-confirmation.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as confirmationt20O3M6iuoMeta } from "/app/pages/reset-password/confirmation.vue?macro=true";
import { default as indexfnbdhqPUvqMeta } from "/app/pages/reset-password/index.vue?macro=true";
import { default as _91token_93ChaHX0P3nLMeta } from "/app/pages/reset-password/reset/[token].vue?macro=true";
import { default as user_45detailsrjvF4OPECdMeta } from "/app/pages/user-details.vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    meta: auth7tE1sZcZDUMeta || {},
    component: () => import("/app/pages/auth.vue").then(m => m.default || m)
  },
  {
    name: "banners-log-in",
    path: "/banners/log-in",
    meta: log_45inne6CMIGdEKMeta || {},
    component: () => import("/app/pages/banners/log-in.vue").then(m => m.default || m)
  },
  {
    name: "banners-logged-in",
    path: "/banners/logged-in",
    meta: logged_45inbikpzH6x9KMeta || {},
    component: () => import("/app/pages/banners/logged-in.vue").then(m => m.default || m)
  },
  {
    name: "banners-promotion-type",
    path: "/banners/promotion/:type()",
    meta: _91type_932G6hlDxcBtMeta || {},
    component: () => import("/app/pages/banners/promotion/[type].vue").then(m => m.default || m)
  },
  {
    name: chatsNJzys5tEDVMeta?.name,
    path: "/chats",
    component: () => import("/app/pages/chats.vue").then(m => m.default || m),
    children: [
  {
    name: "chats-sessionId",
    path: ":sessionId()",
    meta: _91sessionId_93pbuPRYJTKyMeta || {},
    component: () => import("/app/pages/chats/[sessionId].vue").then(m => m.default || m)
  },
  {
    name: "chats",
    path: "",
    component: () => import("/app/pages/chats/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "email-confirmation",
    path: "/email-confirmation",
    meta: email_45confirmationl1UuOPCAKuMeta || {},
    component: () => import("/app/pages/email-confirmation.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "reset-password-confirmation",
    path: "/reset-password/confirmation",
    meta: confirmationt20O3M6iuoMeta || {},
    component: () => import("/app/pages/reset-password/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: indexfnbdhqPUvqMeta || {},
    component: () => import("/app/pages/reset-password/index.vue").then(m => m.default || m)
  },
  {
    name: "reset-password-reset-token",
    path: "/reset-password/reset/:token()",
    meta: _91token_93ChaHX0P3nLMeta || {},
    component: () => import("/app/pages/reset-password/reset/[token].vue").then(m => m.default || m)
  },
  {
    name: "user-details",
    path: "/user-details",
    component: () => import("/app/pages/user-details.vue").then(m => m.default || m)
  }
]